import { memo } from 'react';
import { IconProps } from '../types';

export const ODPLogoDark = memo(({ className, style }: IconProps) => {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 143 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ODP Logo Dark"
    >
      <title>ODP Logo dark</title>
      <path
        d="M137.204 4.5L142.5 4.5L121.917 44.5H116.5L137.204 4.5Z"
        fill="url(#paint0_linear_2962_9565)"
      />
      <path
        d="M33.5 27.5C33.5 35.7843 26.5604 42.5 18 42.5C9.43959 42.5 2.5 35.7843 2.5 27.5C2.5 19.2157 9.43959 12.5 18 12.5C26.5604 12.5 33.5 19.2157 33.5 27.5Z"
        stroke="white"
        strokeWidth="5"
      />
      <path
        d="M73.5 2.5V13.7157V27.8181C73.5 35.9267 67.0081 42.5 59 42.5C50.9919 42.5 44.5 35.9267 44.5 27.8181C44.5 19.7095 50.9919 13.1361 59 13.1361C63.5301 13.1361 58.2439 13.1361 62.774 13.1361"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M85.5 49.5L85.5 25.8708C85.5 18.4863 91.5442 12.5 99 12.5C106.456 12.5 112.5 18.4863 112.5 25.8708C112.5 33.2553 106.456 39.2416 99 39.2416L96.0221 39.2416"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2962_9565"
          x1="131.667"
          y1="4.5"
          x2="131.667"
          y2="44.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0078D6" />
          <stop offset="1" stopColor="#17E3CC" />
        </linearGradient>
      </defs>
    </svg>
  );
});
